import React from "react";
import Button from "./Button";

function App() {
  return (
    <div className="App">
      <Button />
    </div>
  );
}

export default App;